import { environment } from '../../environments/environment';
import { SessionType } from '../_models';

export const OMP_PREVIEW_SUBDOMAIN_TYPE: number = SessionType.CustomerPortal;

const SUBDOMAIN_TOKEN = '{subdomain}';

function sanitizeSubdomain(subdomain: string): string {
  let value = '';
  if (subdomain) {
    value = String(subdomain)
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '');
  }
  return value;
}

export function buildOmpPreviewUrl(subdomain: string, subdomainType: number): string {
  const template = environment.ompPreviewUrl ? environment.ompPreviewUrl : '';
  const host = sanitizeSubdomain(subdomain);
  let url = '';
  if (template && host) {
    const origin = template.split(SUBDOMAIN_TOKEN).join(host);
    const separator = origin.indexOf('?') === -1 ? '?' : '&';
    url = origin + separator + 'preview=' + subdomainType + '&embed_host=angular&embed_height=fill';
  }
  return url;
}

export function ompPreviewOrigin(url: string): string {
  let origin = '';
  try {
    origin = new URL(url).origin;
  } catch (e) {
    origin = '';
  }
  return origin;
}
